import { useLocale, useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import OrderCardItem from '@/components/user/orders/order-card';
import { formatDate, handlePriceByComma } from '@/helpers/common';
import { handleOrderStatus, handleQtyText } from '@/utils/orders';
// import useOrder from '@/hooks/orders/useOrders';
import CurrencyIcon from '../icons/currency-icon';

const OrderCard = ({ order, fromDetails = false, mage }) => {
  const t = useTranslations('user');
  const locale = useLocale();
  const Wrapper = fromDetails ? 'div' : Link;
  const wrapperProps = fromDetails
    ? { className: 'rounded-lg max-lg:relative' }
    : {
        href: `/user/orders/${order?.entity_id}`,
        className: 'rounded-lg max-lg:relative',
      };

  const orderStatusBg = `${handleOrderStatus(order?.state, locale)?.color}`;

  return (
    <Wrapper {...wrapperProps}>
      <div className='bg-primary flex items-center justify-between rounded-t-lg p-4 text-white max-sm:px-4 max-sm:py-2 lg:relative lg:px-6'>
        <div className='max-sm:space-y-1'>
          <p className='text-[11px] sm:text-sm md:text-base'>
            {t('order_placed_key')}
          </p>
          <p className='text-[11px] font-bold sm:text-sm md:text-base'>
            {formatDate(order.created_at, 'M d, yyyy', '', 'date', locale)}.
          </p>
        </div>
        <div className='max-sm:space-y-1'>
          <p className='text-[11px] sm:text-sm md:text-base'>
            {t('order_number_key')}
          </p>
          <p className='text-[11px] font-bold sm:text-sm md:text-base'>
            {order?.increment_id || ''}
          </p>
        </div>
        <div className='hidden md:block'>
          <p className='text-sm md:text-base'>{t('no_products_key')}</p>
          <p className='text-sm font-bold md:text-base'>
            {handleQtyText(Number(order?.total_qty_ordered || 0), locale)}
          </p>
        </div>
        <div
          className={`max-md:text-primary max-md:absolute max-md:end-4 ${!fromDetails ? 'max-md:bottom-2' : 'max-md:bottom-13.5'} max-md:flex max-md:items-center max-md:gap-2 md:block`}
        >
          <p className='text-center max-md:text-sm max-sm:text-xs'>
            {t('total_key')}
          </p>
          <p className='flex items-center gap-1 text-sm font-bold max-sm:text-xs md:text-base'>
            {handlePriceByComma(order?.base_grand_total)}{' '}
            <CurrencyIcon className='size-3 lg:size-3.5' />
          </p>
        </div>
        <div
          className={`absolute right-0 ${!fromDetails ? 'max-md:-bottom-8 md:top-full' : 'top-full max-lg:bottom-4'} rtl:right-auto rtl:left-0`}
        >
          <span
            className='inline-block w-28 text-center text-white max-md:h-8 max-md:text-sm max-sm:flex max-sm:items-center max-sm:justify-center max-sm:text-xs sm:py-1 md:h-9 md:w-48 md:py-1 lg:h-7.5 lg:py-0 ltr:rounded-bl-[20px] rtl:rounded-br-[20px]'
            style={{ backgroundColor: orderStatusBg }}
          >
            {handleOrderStatus(order?.state, locale)?.text}
          </span>
        </div>
      </div>
      <div
        className={`border-border border bg-white px-4 ${!fromDetails ? 'max-lg:mb-12.5 max-md:mb-10.5' : ''} max-sm:py-4.5 lg:mb-6 lg:py-6 ltr:rounded-bl-lg rtl:rounded-br-lg`}
      >
        {order?.items?.map((info, index) => (
          <OrderCardItem
            key={index}
            product={info}
            status={order?.status}
            fromDetails={fromDetails}
            mage={mage}
          />
        ))}
      </div>
    </Wrapper>
  );
};

export default OrderCard;
